import React from 'react'
import Seo from '../components/Seo'
import Nav from '../components/Nav'
import Obfuscate from 'react-obfuscate'

class ContactPage extends React.Component {
  render() {
    const moment = require("moment")
    const now = moment(new Date());
    const r = require('../../content/resume-json/resume-data.js')
    const { data } = this.props
    //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
    const config = require('../../content/meta/config')
    const d = {
      title: "Contact " + config.authorName,
      description: "Contact " + config.authorName + ' at ' + config.shortSiteTitle,
      image: config.siteImage,
      url: config.siteUrl + '/contact',
      keywords: config.resumeKeywords,
      datePublished: "2018-07-01",
      dateUpdated: now.format("YYYY-MM-DD")
    }
    return (
      <div>
        <Seo pageType='contact' data={d} />
        <Nav />
        <p>Say Hello to me at either of the following endopints:</p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            fontSize: '0.8rem',
          }}
        >
          <p
            style={{
              marginBottom: '0px',
            }}
          >
            Phone: <Obfuscate tel={r['mobile']} />
          </p>
          <p
            style={{
              marginBottom: '0px',
            }}
          >
            Email: <Obfuscate email={r['email']} />
          </p>
        </div>
      </div>
    )
  }
}
export default ContactPage
export const pageQuery = graphql`
  query ContactPageQuery {
    site {
      siteMetadata {
        title
        facebook {
          appId
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/contact.js